import { render, staticRenderFns } from "./bottomList.vue?vue&type=template&id=ee4d4ae8&scoped=true"
import script from "./bottomList.vue?vue&type=script&lang=js"
export * from "./bottomList.vue?vue&type=script&lang=js"
import style0 from "./bottomList.vue?vue&type=style&index=0&id=ee4d4ae8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4d4ae8",
  null
  
)

export default component.exports